import { createAction, props } from '@ngrx/store';
import { ServicingSeatmapBackupState } from './servicing-seatmap-backup.state';

/** StateDetailsActions */
const ACTION_SET = '[ServicingSeatmapBackup] set';
const ACTION_UPDATE = '[ServicingSeatmapBackup] update';
const ACTION_RESET = '[ServicingSeatmapBackup] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setServicingSeatmapBackup = createAction(ACTION_SET, props<ServicingSeatmapBackupState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateServicingSeatmapBackup = createAction(ACTION_UPDATE, props<Partial<ServicingSeatmapBackupState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetServicingSeatmapBackup = createAction(ACTION_RESET);